
export const PasswordRule = {
  NUMBER: 'LoginPage.ResetForm.PasswordRule.NUMBER',
  CHARACTER: 'LoginPage.ResetForm.PasswordRule.CHARACTER',
  SYMBOL: 'LoginPage.ResetForm.PasswordRule.SYMBOL',
  MAJUSCULE: 'LoginPage.ResetForm.PasswordRule.MAJUSCULE',
  message: 'LoginPage.ResetForm.PasswordRule.message'
};
